import React from 'react';
import cx from 'classnames';
import './InfoTable.scss';

const InfoTable = (props) => {
  const { className, children } = props;

  return <table className={cx('info-table', className)}>{children}</table>;
};

export default InfoTable;
